import React, { useEffect } from "react";
import { WplywContext } from "../../../../../../../context/wplywContext";
import { useContext } from "react";
import { useState } from "react";
import numberFormat from "../../../../../../../components/numberFormat";
import formatPrice from "../../../../../../../components/formatPrice";

const ProgressBarReckoning = ({personid}) => {
  const {wplyw} = useContext(WplywContext)
  const [procent, setProcent] = useState(0)
  const [leftovers, setLeftovers] = useState(0)
  const [totals, setTotals] = useState(0)

  useEffect(() => {
    const personAmount = parseFloat(wplyw.wplyw_data.data.msr_wplywy.msr_persons.find(x => x.msr_persons_own_id == personid).msr_persons_amount)
    setTotals(personAmount)
    
    const total = wplyw.wplyw_data.data.msr_wplywy.msr_persons.find(x => x.msr_persons_own_id == personid).msr_reckonings.reduce((sum, reck) => sum + parseFloat(reck.msr_reckonings_part_amount), 0)
    setProcent(((total / personAmount) * 100))
    setLeftovers(personAmount - total)
  }, [wplyw, personid])  
  return (
    <div style={{marginTop: '10px'}}>
      <div style={{display: 'flex', width: '100%', justifyContent: 'space-between', padding: '10px', background: '#a5a5a5', borderRadius: '10px', position: 'relative', overflow: 'hidden', alignItems: 'center', gap: '15px'}}>
        <div style={{width: procent+"%", position: 'absolute', height: '100%', background: (wplyw.wplyw_data.data.msr_wplywy.msr_persons.find(x => x.msr_persons_own_id == personid).msr_reckonings.reduce((sum, reck) => sum + parseFloat(reck.msr_reckonings_part_amount), 0)).toFixed(2) == (totals).toFixed(2) ? '#52C41A':'#DC0202', left: '0', top: '0'}}></div>
          <div style={{position: 'relative', zIndex: '4', width: '100%'}}>
            <div style={{color: "white", textAlign: 'right'}}>Kwota całkowita osoby</div>
            <div style={{fontWeight: 700, fontSize: "18px", color: "white", textAlign: 'right'}}>{numberFormat(totals)} zł</div>
          </div>
          <div style={{height: '30px', width: '2px', background: 'white', zIndex: '4'}}></div>
          <div style={{position: 'relative', zIndex: '4', width: '100%'}}>
            <div style={{color: "white", textAlign: 'left'}}>Pozostała kwota</div>
            <div style={{fontWeight: 700, fontSize: "18px", color: "white", textAlign: 'left'}}>
              {leftovers >= 0 ? formatPrice(leftovers)+" zł" : `Przekroczenie kwoty o ${formatPrice(parseFloat(leftovers))+" zł"}`}
            </div>
          </div>
      </div>
    </div>
  );
};

export default ProgressBarReckoning;
